module.exports = __webpack_public_path__ + "static/3-25d8ba3b809c26546c7ce12eb815fecb.jpg";